export default __webpack_public_path__ + "static/kristine-fdbad5bde66df4add2684825ddff48e7.jpg";